import React, { useEffect, useState } from "react";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";
import DenyAccessPage from "../../../components/DenyAccessPage";
import DonutChart from "../../../components/DonutChart";
import NewNavbar from "../../../components/NewNavbar";
import { useAuth } from "../../../context/AuthContext";
import { MONTHS_ARABIC } from "../../../constants/constants";
import {
    XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
    LineChart, Line
} from 'recharts';
import { fetchTMSDashboard } from "../../../services/tms";
// icons
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faPrint, faXmark } from "@fortawesome/free-solid-svg-icons";
// images
// import ebdaeduLogo from "../../../assets/ebad-edu.png";
import addButton from '../../../assets/addButtonImg.png';
// import person from "../../../assets/person.jpg";
// import AlarmModal from "../../../components/alarms/AlarmModal";
// import useAlarmWatcher from "../../../hooks/useAlarmWatcher";
import { useNavigate } from "react-router-dom";
import MonthNavigator from "components/ui/MonthNavigator";
import YearNavigator from "components/ui/YearNavigator";
import { roundNumber } from "utils/roundNumber";
import { fetchWatomsRelatedEmployees } from "services/watoms/watomsData";
import ModelNaviagtionSideBar from "components/ui/ModelNavigationSideBar";

const currentMonth = new Date().getMonth() + 1;
const currentYear = new Date().getFullYear();

// the whole component is getting rerender 3 times why ?
const WatomsTmsDashboard = () => {
    const { userInfo } = useAuth();
    const navigate = useNavigate();
    const [employees, setEmployees] = useState([]);
    const [allTasks, setAllTasks] = useState([]);
    const [year, setYear] = useState(currentYear);
    const [selectedMonthIdx, setSelectedMonthIdx] = useState(currentMonth);
    const [selectedEmployee, setSelectedEmployee] = useState(userInfo?.employee_id);
    const [currentMonthTasks, setCurrentMonthTasks] = useState(null);

    // old logic
    // const pdfRef = useRef();
    // const [pdfStatus, setPdfStatus] = useState(false);
    const [, setShowTablePopup] = useState(false);
    // const [selectedMonthTasks, setSelectedMonthTasks] = useState({});
    // const [monthlyPerformance, setMonthlyPerformance] = useState([]);

    // fetch Employees' data
    useEffect(() => {
        const loadEmployees = async () => {
            const response = await fetchWatomsRelatedEmployees(userInfo);
            setEmployees(response)
        }

        loadEmployees();
    }, [userInfo])

    // still needs to apply year filter
    useEffect(() => {
        const loadMyTasks = async () => {
            try {
                const response = await fetchTMSDashboard({
                    system: "watoms",
                    employee_id: selectedEmployee
                });

                setAllTasks(response || []);

                const currentMonthTasks = response?.find(
                    tasks => tasks.monthNumber === selectedMonthIdx
                );

                setCurrentMonthTasks(currentMonthTasks || null);
            } catch (error) {
                console.error("Failed to load dashboard", error);
            }
        };

        loadMyTasks();
    }, [userInfo, selectedEmployee, selectedMonthIdx]);

    // create pdf to download
    // const handleDownloadPdf = async () => {
    //     const element = pdfRef.current;

    //     // Create a high-res canvas of the element
    //     const canvas = await html2canvas(element, {
    //         scale: 2, // higher scale = better quality
    //         useCORS: true, // allows external images like logos
    //     });

    //     const imageData = canvas.toDataURL("image/png");
    //     const pdf = new jsPDF("p", "mm", "a4");

    //     const pdfWidth = pdf.internal.pageSize.getWidth();
    //     const pdfHeight = pdf.internal.pageSize.getHeight();

    //     const imgWidth = pdfWidth;
    //     const imgHeight = (canvas.height * pdfWidth) / canvas.width;

    //     let heightLeft = imgHeight;
    //     let position = 0;

    //     // Add first page
    //     pdf.addImage(imageData, "PNG", 0, position, imgWidth, imgHeight);
    //     heightLeft -= pdfHeight;

    //     // Add extra pages if needed
    //     while (heightLeft > 0) {
    //         position = heightLeft - imgHeight;
    //         pdf.addPage();
    //         pdf.addImage(imageData, "PNG", 0, position, imgWidth, imgHeight);
    //         heightLeft -= pdfHeight;
    //     }

    //     pdf.save("report.pdf");
    // };

    // create the pdf template to view
    // const PdfPages = () => (
    //     <div className="fixed inset-0 bg-black/60 flex flex-col overflow-y-auto justify-start gap-6 items-center z-50">
    //         <button
    //             onClick={() => setPdfStatus(false)}
    //             className="absolute top-4 right-4 text-white bg-gray-700 hover:bg-gray-800 w-12 h-12 flex justify-center items-center text-2xl font-bold cursor-pointer z-50"
    //         >
    //             <FontAwesomeIcon icon={faXmark} />
    //         </button>
    //         <button
    //             onClick={handleDownloadPdf}
    //             className="absolute top-4 right-20 text-white bg-gray-700 hover:bg-gray-800 w-12 h-12 flex justify-center items-center text-2xl font-bold cursor-pointer z-50"
    //         >
    //             <FontAwesomeIcon icon={faPrint} />
    //         </button>
    //         <div ref={pdfRef} className="relative bg-white w-[40%] max-w-5xl h-fit p-4 flex flex-col">
    //             <div className="rounded-2xl border-black border-2 h-full flex flex-col items-center gap-2 p-2">
    //                 {/* Header */}
    //                 <div className="flex justify-between items-center w-full">
    //                     {/* logo */}
    //                     <div className="flex flex-col">
    //                         <img src={ebdaeduLogo} className="w-10" alt="ebda edu logo" />
    //                     </div>
    //                     {/* title */}
    //                     <div className="flex flex-col items-center gap-2 text-xs font-bold">
    //                         <h1 className="border-b-2 border-black">تقرير ملخص اداء المهام في الفترة من الي</h1>
    //                     </div>
    //                     <div className="w-10" />
    //                 </div>
    //                 {/* user's Summary */}
    //                 <div className="w-full border-black border-2 flex p-1 gap-1 min-h-20">
    //                     {/* total score */}
    //                     <div className="flex flex-col items-center text-center gap-1 w-[15%] font-bold">
    //                         <div className="text-[10px] border-black border-2 w-full bg-gray-300 h-1/2 flex justify-center items-center">اجمالي التقييم</div>
    //                         <div className="text-sm border-black border-2 w-full h-1/2 flex justify-center items-center">{`0%`}</div>
    //                     </div>
    //                     {/* no of tasks */}
    //                     <div className="flex flex-col items-center text-center gap-1 w-[15%] font-bold">
    //                         <div className="text-[10px] border-black border-2 w-full bg-gray-300 h-1/2 flex justify-center items-center">اجمالي عدد المهام</div>
    //                         <div className="text-sm border-black border-2 w-full h-1/2 flex justify-center items-center">{selectedMonthTasks?.tasks?.length}</div>
    //                     </div>
    //                     {/* orgs titles */}
    //                     <div className="flex flex-col gap-1 w-1/3 text-[10px] font-bold justify-center items-center">
    //                         <div className="border-black border-2 h-fit w-full text-center px-2 py-1 flex justify-center items-center">EBDA EDU</div>
    //                         <div className="border-black border-2 h-fit w-full text-center px-2 py-1 flex justify-center items-center">EBDA EDU</div>
    //                     </div>
    //                     {/* orgs details */}
    //                     <div className="flex flex-col gap-1 min-w-fit max-w-1/3 text-[10px] font-bold justify-center items-center">
    //                         <div className="border-black border-2 h-fit w-full text-center px-2 py-1 flex justify-center items-center bg-gray-300">الجهة الرئيسية</div>
    //                         <div className="border-black border-2 h-fit w-full text-center px-2 py-1 flex justify-center items-center bg-gray-300">الجهة الفرعية</div>
    //                     </div>
    //                     {/* user's photo */}
    //                     <div className="border-black border-2 p-1">
    //                         <img className="w-16" src={person} alt="" />
    //                     </div>
    //                     <div className="flex justify-center items-center">
    //                         <div className="px-2 bg-gray-300 border-black border-2 text-xs">1</div>
    //                     </div>
    //                 </div>

    //                 {/* tasks' summary */}
    //                 <h1 className="w-full text-end font-bold underline">اولا: اهم الاحصائيات</h1>
    //                 <div className="w-full h-fit flex items-center gap-2 p-4 border-black border-2">
    //                     <div className="flex-1 flex flex-col gap-2">
    //                         <div className={`text-white text-center rounded p-2 bg-[#2f417a]`}>الاجماليات</div>
    //                         <div className="flex gap-2">
    //                             <div className="flex-1 flex flex-col gap-1">
    //                                 <div className={`text-white text-center text-[8px] rounded p-2 bg-[#2f417a]`}>اجمالي عدد المهام المنجزة</div>
    //                                 <div className={`border-black p-2 border-2 rounded text-center font-bold`}>0</div>
    //                             </div>
    //                             <div className="flex-1 flex flex-col gap-1">
    //                                 <div className={`text-white text-center text-[8px] rounded p-2 bg-[#2f417a]`}>اجمالي عدد المهام الغير منجزة</div>
    //                                 <div className={`border-black p-2 border-2 rounded text-center font-bold`}>0</div>
    //                             </div>
    //                             <div className="flex-1 flex flex-col gap-1">
    //                                 <div className={`text-white text-center text-[8px] rounded p-2 bg-[#2f417a]`}>اجمالي عدد المهام الغير منجزة</div>
    //                                 <div className={`border-black p-2 border-2 rounded text-center font-bold`}>0</div>
    //                             </div>
    //                         </div>
    //                     </div>
    //                     <div className="flex-1 flex flex-col gap-2 justify-start">
    //                         <div className={`text-white text-center rounded p-2 bg-[#2f417a]`}>مهام اقل من (%50)</div>
    //                         <div className="w-full flex justify-evenly gap-2">
    //                             <div className="flex-1 flex flex-col gap-2">
    //                                 <div className={`text-center rounded p-2 bg-[#5268b1] text-white text-xs`}>اولوية قصوي</div>
    //                                 <div className={`flex justify-center items-center border-black px-2 border-2 rounded text-center font-bold text-black`}>0</div>
    //                             </div>
    //                             <div className="flex-1 flex flex-col gap-2">
    //                                 <div className={`text-center rounded p-2 bg-[#5268b1] text-white text-xs`}>اولوية متوسطة</div>
    //                                 <div className={`flex justify-center items-center border-black px-2 border-2 rounded text-center font-bold text-black`}>0</div>
    //                             </div>
    //                             <div className="flex-1 flex flex-col gap-2">
    //                                 <div className={`text-center rounded py-2 px-3 bg-[#5268b1] text-white text-xs`}>اولوية عادية</div>
    //                                 <div className={`flex justify-center items-center border-black px-2 border-2 rounded text-center font-bold text-black`}>0</div>
    //                             </div>
    //                         </div>
    //                     </div>
    //                 </div>

    //                 {/* user's tasks score summary */}
    //                 <h1 className="w-full text-end font-bold underline">ثانيا: تقييم معايير معدل تنفيذ المهام</h1>
    //                 <div className="w-full h-fit flex flex-col items-center gap-4 p-4 border-black border-2">
    //                     <div className="flex items-center gap-2 w-full">
    //                         <div
    //                             className="w-[75%] flex flex-col justify-start overflow-y-auto overflow-x-hidden"
    //                             style={{
    //                                 minHeight: 60,
    //                                 maxHeight: 300,
    //                                 zIndex: 1,
    //                                 marginTop: 9
    //                             }}
    //                         >
    //                             <div
    //                                 style={{
    //                                     display: 'flex',
    //                                     alignItems: 'center',
    //                                     marginBottom: 0,
    //                                     cursor: 'pointer',
    //                                     transition: 'transform 0.2s ease, opacity 0.2s ease',
    //                                     borderRadius: 8,
    //                                     minWidth: 0,
    //                                     transformOrigin: 'center',
    //                                 }}
    //                                 className="justify-between hover:bg-gray-600 hover:bg-opacity-20 py-[4px] px-6"
    //                                 onMouseEnter={(e) => {
    //                                     e.currentTarget.style.transform = 'scale(1.02)';
    //                                     e.currentTarget.style.opacity = '0.9';
    //                                 }}
    //                                 onMouseLeave={(e) => {
    //                                     e.currentTarget.style.transform = 'scale(1)';
    //                                     e.currentTarget.style.opacity = '1';
    //                                 }}
    //                             >
    //                                 {/* Center name (on the left) */}
    //                                 <div className="text-start min-w-36" style={{
    //                                     maxWidth: 120,
    //                                     fontWeight: 900,
    //                                     fontSize: 15,
    //                                     marginRight: 8,
    //                                     overflow: 'hidden',
    //                                     textOverflow: 'ellipsis',
    //                                     whiteSpace: 'nowrap',
    //                                     transition: 'color 0.2s ease'
    //                                 }}>
    //                                     سرعة التنفيذ المهام
    //                                 </div>
    //                                 {/* Bar background with fixed width */}
    //                                 <div style={{
    //                                     flex: 1,                   // ✅ take remaining space
    //                                     minWidth: 0,
    //                                     maxWidth: 170,              // ✅ allow shrink
    //                                     height: 20,
    //                                     background: '#444652',
    //                                     borderRadius: 18,
    //                                     boxShadow: '0 2px 8px #0002',
    //                                     position: 'relative',
    //                                     overflow: 'hidden',
    //                                     marginLeft: 8,
    //                                     marginRight: 8,
    //                                     transition: 'box-shadow 0.2s ease',
    //                                 }}
    //                                 >
    //                                     {/* Bar fill */}
    //                                     <div
    //                                         style={{
    //                                             height: '100%',
    //                                             width: `0%`,
    //                                             background: "red",
    //                                             borderRadius: 18,
    //                                             transition: 'width 0.7s cubic-bezier(.4,2,.6,1)',
    //                                         }}
    //                                     />
    //                                 </div>
    //                                 {/* Percentage (on the right) */}
    //                                 <div className="text-end" style={{
    //                                     minWidth: 38,
    //                                     fontWeight: 900,
    //                                     fontSize: 17,
    //                                     textAlign: 'right',
    //                                     marginLeft: 0,
    //                                     marginRight: 0,
    //                                     transition: 'color 0.2s ease'
    //                                 }}>
    //                                     0%
    //                                 </div>
    //                             </div>
    //                             <div
    //                                 style={{
    //                                     display: 'flex',
    //                                     alignItems: 'center',
    //                                     marginBottom: 0,
    //                                     cursor: 'pointer',
    //                                     transition: 'transform 0.2s ease, opacity 0.2s ease',
    //                                     borderRadius: 8,
    //                                     minWidth: 0,
    //                                     transformOrigin: 'center',
    //                                 }}
    //                                 className="justify-between hover:bg-gray-600 hover:bg-opacity-20 py-[4px] px-6"
    //                                 onMouseEnter={(e) => {
    //                                     e.currentTarget.style.transform = 'scale(1.02)';
    //                                     e.currentTarget.style.opacity = '0.9';
    //                                 }}
    //                                 onMouseLeave={(e) => {
    //                                     e.currentTarget.style.transform = 'scale(1)';
    //                                     e.currentTarget.style.opacity = '1';
    //                                 }}
    //                             >
    //                                 {/* Center name (on the left) */}
    //                                 <div className="text-start min-w-36" style={{
    //                                     maxWidth: 120,
    //                                     fontWeight: 900,
    //                                     fontSize: 15,
    //                                     marginRight: 8,
    //                                     overflow: 'hidden',
    //                                     textOverflow: 'ellipsis',
    //                                     whiteSpace: 'nowrap',
    //                                     transition: 'color 0.2s ease'
    //                                 }}>
    //                                     دقة التنفيذ المهام
    //                                 </div>
    //                                 {/* Bar background with fixed width */}
    //                                 <div style={{
    //                                     flex: 1,                   // ✅ take remaining space
    //                                     minWidth: 0,
    //                                     maxWidth: 170,              // ✅ allow shrink
    //                                     height: 20,
    //                                     background: '#444652',
    //                                     borderRadius: 18,
    //                                     boxShadow: '0 2px 8px #0002',
    //                                     position: 'relative',
    //                                     overflow: 'hidden',
    //                                     marginLeft: 8,
    //                                     marginRight: 8,
    //                                     transition: 'box-shadow 0.2s ease',
    //                                 }}
    //                                 >
    //                                     {/* Bar fill */}
    //                                     <div
    //                                         style={{
    //                                             height: '100%',
    //                                             width: `0%`,
    //                                             background: "blue",
    //                                             borderRadius: 18,
    //                                             transition: 'width 0.7s cubic-bezier(.4,2,.6,1)',
    //                                         }}
    //                                     />
    //                                 </div>
    //                                 {/* Percentage (on the right) */}
    //                                 <div className="text-end" style={{
    //                                     minWidth: 38,
    //                                     fontWeight: 900,
    //                                     fontSize: 17,
    //                                     textAlign: 'right',
    //                                     marginLeft: 0,
    //                                     marginRight: 0,
    //                                     transition: 'color 0.2s ease'
    //                                 }}>
    //                                     0%
    //                                 </div>
    //                             </div>
    //                             <div
    //                                 style={{
    //                                     display: 'flex',
    //                                     alignItems: 'center',
    //                                     marginBottom: 0,
    //                                     cursor: 'pointer',
    //                                     transition: 'transform 0.2s ease, opacity 0.2s ease',
    //                                     borderRadius: 8,
    //                                     minWidth: 0,
    //                                     transformOrigin: 'center',
    //                                 }}
    //                                 className="justify-between hover:bg-gray-600 hover:bg-opacity-20 py-[4px] px-6"
    //                                 onMouseEnter={(e) => {
    //                                     e.currentTarget.style.transform = 'scale(1.02)';
    //                                     e.currentTarget.style.opacity = '0.9';
    //                                 }}
    //                                 onMouseLeave={(e) => {
    //                                     e.currentTarget.style.transform = 'scale(1)';
    //                                     e.currentTarget.style.opacity = '1';
    //                                 }}
    //                             >
    //                                 {/* Center name (on the left) */}
    //                                 <div className="text-start min-w-36" style={{
    //                                     maxWidth: 120,
    //                                     fontWeight: 900,
    //                                     fontSize: 15,
    //                                     marginRight: 8,
    //                                     overflow: 'hidden',
    //                                     textOverflow: 'ellipsis',
    //                                     whiteSpace: 'nowrap',
    //                                     transition: 'color 0.2s ease'
    //                                 }}>
    //                                     نسبة اكتمال المهام
    //                                 </div>
    //                                 {/* Bar background with fixed width */}
    //                                 <div style={{
    //                                     flex: 1,                   // ✅ take remaining space
    //                                     minWidth: 0,
    //                                     maxWidth: 170,              // ✅ allow shrink
    //                                     height: 20,
    //                                     background: '#444652',
    //                                     borderRadius: 18,
    //                                     boxShadow: '0 2px 8px #0002',
    //                                     position: 'relative',
    //                                     overflow: 'hidden',
    //                                     marginLeft: 8,
    //                                     marginRight: 8,
    //                                     transition: 'box-shadow 0.2s ease',
    //                                 }}
    //                                 >
    //                                     {/* Bar fill */}
    //                                     <div
    //                                         style={{
    //                                             height: '100%',
    //                                             width: `0%`,
    //                                             background: "green",
    //                                             borderRadius: 18,
    //                                             transition: 'width 0.7s cubic-bezier(.4,2,.6,1)',
    //                                         }}
    //                                     />
    //                                 </div>
    //                                 {/* Percentage (on the right) */}
    //                                 <div className="text-end" style={{
    //                                     minWidth: 38,
    //                                     fontWeight: 900,
    //                                     fontSize: 17,
    //                                     textAlign: 'right',
    //                                     marginLeft: 0,
    //                                     marginRight: 0,
    //                                     transition: 'color 0.2s ease'
    //                                 }}>
    //                                     0%
    //                                 </div>
    //                             </div>
    //                         </div>
    //                         <div className='border-l-2 border-white p-1 h-12 w-0' />
    //                         <div className="flex flex-col gap-2 items-center">
    //                             <DonutChart value={0} size={90} color='url(#circularBlueGradient)' bg='#23263a' textColor='#fff' />
    //                             <div className="flex p-2 border-black border-2 gap-2">
    //                                 <h1>مهمة</h1>
    //                                 <h1>{selectedMonthTasks?.tasksCount}</h1>
    //                             </div>
    //                         </div>
    //                     </div>
    //                 </div>
    //                 {/* user's line chart */}
    //                 <h1 className="w-full text-end font-bold underline">ثالثا: تحليل معدل تغيير الاداء</h1>
    //                 <div className="w-full h-fit p-2 border-black border-2">
    //                     <ResponsiveContainer width="100%" height={200}>
    //                         <LineChart
    //                             data={MONTHS_ARABIC.map(m => {
    //                                 const found = allTasks.find(t => t.monthNumber === m.monthNumber);
    //                                 return found ? found : { ...m, performance: 0 };
    //                             })}
    //                             margin={{ top: 6, right: 30, left: -25, bottom: -10 }}
    //                         >
    //                             <CartesianGrid strokeDasharray="3 3" stroke="#4a5568" /> {/* optional grey grid */}
    //                             <XAxis
    //                                 dataKey="month"
    //                                 axisLine={false}
    //                                 tickLine={false}
    //                                 tick={{ fontSize: 12, fill: "black" }} // ← white x-axis text
    //                             />
    //                             <YAxis
    //                                 axisLine={false}
    //                                 tickLine={false}
    //                                 tick={{ fontSize: 12, fill: "black" }} // ← white y-axis text
    //                                 domain={[0, 100]}
    //                             />
    //                             <Tooltip
    //                                 contentStyle={{
    //                                     backgroundColor: "#1a202c",
    //                                     border: "1px solid #4a5568",
    //                                     borderRadius: "6px",
    //                                     color: "#ffffff", // ← white tooltip text
    //                                 }}
    //                                 labelStyle={{ color: "#ffffff" }} // ← white label
    //                                 itemStyle={{ color: "#ffffff" }} // ← white items
    //                             />
    //                             <Line
    //                                 type="monotone"
    //                                 dataKey="performance"
    //                                 stroke="#fbbf24"
    //                                 strokeWidth={2}
    //                                 dot={{ r: 5, fill: "#fbbf24" }}
    //                                 activeDot={{ r: 7, stroke: "#fff", strokeWidth: 2 }}
    //                                 label={({ x, y, value }) => (
    //                                     <text
    //                                         x={x}
    //                                         y={y - 10} // move up a little
    //                                         textAnchor="middle"
    //                                         fill="#ffffff"
    //                                         fontSize={12}
    //                                         fontWeight="bold"
    //                                     >
    //                                         {value}%
    //                                     </text>
    //                                 )}
    //                             />
    //                         </LineChart>
    //                     </ResponsiveContainer>
    //                 </div>

    //                 {/* task's details */}
    //                 <div className="h-[35vh] flex items-center">
    //                     <div className="w-full flex flex-row-reverse gap-3 text-white text-xs cursor-pointer" onClick={() => setShowTablePopup(true)}>
    //                         {/* === Priority columns === */}
    //                         <div className="flex-1 flex flex-col gap-3">
    //                             {/* === Top section: إجمالي العدد === */}
    //                             <div className="overflow-hidden rounded-xl border border-white/30 bg-[#5268b1] shadow-sm">
    //                                 <table className="w-full table-fixed border-collapse" dir="rtl">
    //                                     <thead>
    //                                         <tr className="bg-[#5268b1] border-b border-white/30">
    //                                             <th className="py-2 text-center font-semibold border-l border-white/30">البند</th>
    //                                             <th className="py-2 text-center font-semibold border-l border-white/30">أولوية قصوى</th>
    //                                             <th className="py-2 text-center font-semibold border-l border-white/30">أولوية متوسطة</th>
    //                                             <th className="py-2 text-center font-semibold">أولوية عادية</th>
    //                                         </tr>
    //                                     </thead>
    //                                     <tbody>
    //                                         <tr className="bg-[#2f417a] hover:bg-[#3b4e93] transition">
    //                                             <td className="py-2 text-center border-l border-white/30">إجمالي العدد</td>
    //                                             {[0, 0, 0].map(
    //                                                 (value, i) => (
    //                                                     <td key={i} className="py-2 text-center border-l border-white/30">
    //                                                         <span className="inline-flex items-center justify-center min-w-[2.25rem] px-2 h-6 rounded-full bg-white/20">
    //                                                             {value}
    //                                                         </span>
    //                                                     </td>
    //                                                 )
    //                                             )}
    //                                         </tr>
    //                                     </tbody>
    //                                 </table>
    //                             </div>

    //                             {/* === Bottom section: other rows === */}
    //                             <div className="overflow-hidden rounded-xl border border-white/30 bg-[#5268b1] shadow-sm">
    //                                 <table className="w-full table-fixed border-collapse" dir="rtl">
    //                                     <tbody>
    //                                         {[
    //                                             {
    //                                                 label: "إجمالي نسبة الاستكمال",
    //                                                 values: [
    //                                                     `0%`,
    //                                                     `0%`,
    //                                                     `0%`,
    //                                                 ],
    //                                             },
    //                                             { label: "إجمالي مستوى الدقة", values: [`0%`, `0%`, `0%`] },
    //                                             { label: "إجمالي معدل السرعة", values: [`0%`, `0%`, `0%`] },
    //                                             { label: "إجمالي التقييم", values: [`0%`, `0%`, `0%`] },
    //                                         ].map((row, index) => (
    //                                             <tr
    //                                                 key={index}
    //                                                 className="bg-[#2f417a] border-t border-white/20 hover:bg-[#3b4e93] transition"
    //                                             >
    //                                                 <td className="py-2 text-center border-l border-white/30">{row.label}</td>
    //                                                 {row.values.map((value, i) => (
    //                                                     <td key={i} className="py-2 text-center border-l border-white/30">
    //                                                         <span className="inline-flex items-center justify-center min-w-[2.25rem] px-2 h-6 rounded-full bg-white/20">
    //                                                             {value}
    //                                                         </span>
    //                                                     </td>
    //                                                 ))}
    //                                             </tr>
    //                                         ))}
    //                                     </tbody>
    //                                 </table>
    //                             </div>
    //                         </div>

    //                         {/* === Total column (الإجمالي) === */}
    //                         <div className="flex-1 max-w-[6rem] flex flex-col gap-3">
    //                             {/* === Top section (إجمالي العدد) === */}
    //                             <div className="overflow-hidden rounded-xl border border-white/30 bg-[#4459a8] shadow-sm">
    //                                 <table className="w-full border-collapse" dir="rtl">
    //                                     <thead>
    //                                         <tr className="bg-[#4459a8] border-b border-white/30">
    //                                             <th className="py-2 text-center font-semibold">الإجمالي</th>
    //                                         </tr>
    //                                     </thead>
    //                                     <tbody>
    //                                         <tr className="bg-[#2f417a] hover:bg-[#3b4e93] transition">
    //                                             <td className="py-2 text-center">
    //                                                 <span className="inline-flex items-center justify-center min-w-[2.25rem] px-2 h-6 rounded-full bg-white/20">
    //                                                     {selectedMonthTasks?.tasksCount}
    //                                                 </span>
    //                                             </td>
    //                                         </tr>
    //                                     </tbody>
    //                                 </table>
    //                             </div>

    //                             {/* === Bottom section (other rows) === */}
    //                             <div className="overflow-hidden rounded-xl border border-white/30 bg-[#4459a8] shadow-sm">
    //                                 <table className="w-full border-collapse" dir="rtl">
    //                                     <tbody>
    //                                         {[
    //                                             { label: "إجمالي نسبة الاستكمال", value: `0%` },
    //                                             { label: "إجمالي مستوى الدقة", value: `0%` },
    //                                             { label: "إجمالي معدل السرعة", value: `0%` },
    //                                             { label: "إجمالي التقييم", value: `0%` },
    //                                         ].map((row, index) => (
    //                                             <tr
    //                                                 key={index}
    //                                                 className="bg-[#2f417a] border-t border-white/20 hover:bg-[#3b4e93] transition"
    //                                             >
    //                                                 <td className="py-2 text-center">
    //                                                     <span className="inline-flex items-center justify-center min-w-[2.25rem] px-2 h-6 rounded-full bg-white/20">
    //                                                         {row.value}
    //                                                     </span>
    //                                                 </td>
    //                                             </tr>
    //                                         ))}
    //                                     </tbody>
    //                                 </table>
    //                             </div>
    //                         </div>
    //                     </div>
    //                 </div>
    //             </div>
    //         </div>
    //     </div>
    // );

    // Month Toggle
    const toggleMonth = (status) => {
        if (status) {
            if (selectedMonthIdx !== currentMonth) {
                setSelectedMonthIdx(prev => prev + 1);
                setCurrentMonthTasks(allTasks.find(t => t.monthNumber === selectedMonthIdx + 1) || {});
            }
        } else {
            if (selectedMonthIdx !== 1) {
                setSelectedMonthIdx(prev => prev - 1);
                setCurrentMonthTasks(allTasks.find(t => t.monthNumber === selectedMonthIdx - 1) || {});
            }
        }
    }


    // useAlarmWatcher(userInfo?.id, (alarm) => {
    //     // 👇 Replace this with your notification system later
    //     alert(`⏰ Alarm triggered: ${alarm.label}`);
    // });

    const test = (importance, column) => {
        return currentMonthTasks?.tasks?.filter(task => task.importance === importance).reduce((total, item) => total + item[column], 0) / currentMonthTasks?.tasks?.filter(task => task.importance === importance).length
    }

    if (userInfo?.code === 1452 || userInfo?.code === 1476) return <DenyAccessPage homePage='/watoms/dashboard' />;
    if (userInfo?.code === 1475) return <DenyAccessPage homePage='/watoms/news' />;
    if (userInfo?.code === 1310) return <DenyAccessPage homePage='/wisdom/dashboard' />;
    return (
        <>
            <ModelNaviagtionSideBar system="watoms" />
            <NewNavbar
                plusStatus={true}
                searchStatus={false}
                darkmodeStatus={false}
            // notificationStatus={true}
            >
                {/* <AlarmModal userId={userInfo?.id} /> */}
                {/* open Pdf */}
                {/* <button onClick={() => setPdfStatus(true)} className="rounded-full w-10 h-10 flex justify-center items-center bg-white/80 hover:bg-gray-200 shadow transition-all">
                    <FontAwesomeIcon icon={faPrint} className="text-xl text-gray-500" />
                </button> */}
                <button onClick={() => navigate('/watoms/tms/my-tasks')} className="rounded-full w-10 h-10 flex justify-center items-center bg-white/80 hover:bg-gray-200 shadow transition-all p-2">
                    <img src={addButton} alt="" />
                </button>
            </NewNavbar>
            <div className="text-white bg-[#0a183d] md:h-[88vh] h-fit px-12">
                <div className="w-full md:h-[12%] h-fit flex md:flex-row flex-col justify-between items-center">
                    <div className="w-fit flex flex-col justify-center gap-1 py-3">
                        <YearNavigator year={year} setYear={setYear} />
                        <MonthNavigator
                            selectedMonthIdx={selectedMonthIdx}
                            onPrev={() => toggleMonth(false)}
                            onNext={() => toggleMonth(true)}
                        />
                    </div>
                    <h1 className="text-2xl font-bold text-center text-yellow-500">Dashboard</h1>
                    {(userInfo?.code === 3 || userInfo?.code === 1 || userInfo?.code === 2) && <div className="w-fit flex md:flex-row flex-col gap-2 px-2">
                        <div className="w-44 flex flex-col items-center">
                            <label className="text-sm font-semibold text-gray-200 mb-1">
                                المنفذيين
                            </label>
                            <select value={selectedEmployee} onChange={(e) => setSelectedEmployee(e.target.value)} className="w-full text-center px-2 py-1 rounded-md bg-[#181f2e] text-white border border-gray-600 focus:border-[#0af] focus:outline-none cursor-pointer">
                                <option value="">الرجاء اختيار المنفذ</option>
                                {employees.map(emp => (
                                    <option value={emp.id}>{emp.employee.first_name} {emp.employee.middle_name} {emp.employee.last_name}</option>
                                ))}
                            </select>
                        </div>
                    </div>}
                </div>
                <div className="md:h-[85%] h-fit flex md:flex-row flex-col justify-evenly gap-4">
                    {/* left column */}
                    <div className="flex-1 h-full flex flex-col gap-4">
                        {/* upper card (total score) */}
                        <div className="flex-1 flex flex-col justify-center items-center gap-4 text-white bg-[#2d3347] rounded-2xl shadow-md shadow-black px-2">
                            <h1 className="text-center font-bold underline">تقييم معايير معدل تنفيذ المهام</h1>
                            <div className="w-full flex justify-evenly items-center gap-2">
                                <div className="w-[75%] min-h-[60px] max-h-[300px] flex flex-col justify-start overflow-y-auto overflow-x-hidden mt-[9px]"
                                    style={{
                                        zIndex: 1,
                                    }}
                                >
                                    <div
                                        style={{
                                            transition: 'transform 0.2s ease, opacity 0.2s ease',
                                            borderRadius: 8,
                                            transformOrigin: 'center',
                                        }}
                                        className="min-w-0 flex justify-between items-center hover:bg-gray-600 hover:bg-opacity-20 cursor-pointer py-[4px] px-6 mb-0"
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = 'scale(1.02)';
                                            e.currentTarget.style.opacity = '0.9';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = 'scale(1)';
                                            e.currentTarget.style.opacity = '1';
                                        }}
                                    >
                                        {/* Center name (on the left) */}
                                        <div className="min-w-fit w-[40%] text-[15px] text-[#fff] text-start overflow-hidden" style={{
                                            fontWeight: 900,
                                            marginRight: 8,
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            transition: 'color 0.2s ease'
                                        }}>
                                            سرعة التنفيذ المهام
                                        </div>
                                        {/* Bar background with fixed width */}
                                        <div className={`flex-1 relative w-full h-[20px] bg-[#444652] overflow-hidden mx-[8px]`}
                                            style={{
                                                borderRadius: 18,
                                                boxShadow: '0 2px 8px #0002',
                                                transition: 'box-shadow 0.2s ease',
                                            }}
                                        >
                                            {/* Bar fill */}
                                            <div className={`h-full bg-red-600`}
                                                style={{
                                                    width: `${(currentMonthTasks?.manager_speed + currentMonthTasks?.reviewer_speed) / 2 || 0}%`,
                                                    borderRadius: 18,
                                                    transition: 'width 0.7s cubic-bezier(.4,2,.6,1)',
                                                }}
                                            />
                                        </div>
                                        {/* Percentage (on the right) */}
                                        <div className="min-w-[38px] w-[10%] text-[17px] text-white text-end mx-0" style={{
                                            fontWeight: 900,
                                            transition: 'color 0.2s ease'
                                        }}>
                                            {roundNumber((currentMonthTasks?.manager_speed + currentMonthTasks?.reviewer_speed) / 2 || 0)}%
                                        </div>
                                    </div>
                                    <div
                                        style={{
                                            transition: 'transform 0.2s ease, opacity 0.2s ease',
                                            borderRadius: 8,
                                            transformOrigin: 'center',
                                        }}
                                        className="min-w-0 flex justify-between items-center hover:bg-gray-600 hover:bg-opacity-20 cursor-pointer py-[4px] px-6 mb-0"
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = 'scale(1.02)';
                                            e.currentTarget.style.opacity = '0.9';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = 'scale(1)';
                                            e.currentTarget.style.opacity = '1';
                                        }}
                                    >
                                        {/* Center name (on the left) */}
                                        <div className="w-[40%] text-[15px] text-[#fff] text-start min-w-fit mr-[8px] overflow-hidden" style={{
                                            fontWeight: 900,
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            transition: 'color 0.2s ease'
                                        }}>
                                            دقة التنفيذ المهام
                                        </div>
                                        {/* Bar background with fixed width */}
                                        <div className="flex-1 relative min-w-0 w-[40%] h-[20px] bg-[#444652] overflow-hidden mx-[8px]"
                                            style={{
                                                borderRadius: 18,
                                                boxShadow: '0 2px 8px #0002',
                                                transition: 'box-shadow 0.2s ease',
                                            }}
                                        >
                                            {/* Bar fill */}
                                            <div className={`h-full bg-blue-600`}
                                                style={{
                                                    width: `${roundNumber((currentMonthTasks?.manager_quality + currentMonthTasks?.reviewer_quality) / 2) || 0}%`,
                                                    borderRadius: 18,
                                                    transition: 'width 0.7s cubic-bezier(.4,2,.6,1)',
                                                }}
                                            />
                                        </div>
                                        {/* Percentage (on the right) */}
                                        <div className="min-w-[38px] w-[10%] text-[17px] text-white text-end mx-0" style={{
                                            fontWeight: 900,
                                            transition: 'color 0.2s ease'
                                        }}>
                                            {roundNumber((currentMonthTasks?.manager_quality + currentMonthTasks?.reviewer_quality) / 2) || 0}%
                                        </div>
                                    </div>
                                    <div
                                        style={{
                                            transition: 'transform 0.2s ease, opacity 0.2s ease',
                                            borderRadius: 8,
                                            transformOrigin: 'center',
                                        }}
                                        className="min-w-0 flex justify-between items-center hover:bg-gray-600 hover:bg-opacity-20 cursor-pointer py-[4px] px-6 mb-0"
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = 'scale(1.02)';
                                            e.currentTarget.style.opacity = '0.9';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = 'scale(1)';
                                            e.currentTarget.style.opacity = '1';
                                        }}
                                    >
                                        {/* Center name (on the left) */}
                                        <div className="w-[40%] min-w-fit text-[15px] text-[#fff] text-start overflow-hidden mr-[8px]" style={{
                                            fontWeight: 900,
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            transition: 'color 0.2s ease'
                                        }}>
                                            نسبة اكتمال المهام
                                        </div>
                                        {/* Bar background with fixed width */}
                                        <div className="flex-1 relative min-w-0 w-[40%] h-[20px] bg-[#444652] overflow-hidden mx-[8px]"
                                            style={{
                                                borderRadius: 18,
                                                boxShadow: '0 2px 8px #0002',
                                                transition: 'box-shadow 0.2s ease',
                                            }}
                                        >
                                            {/* Bar fill */}
                                            <div className={`h-full bg-green-600`}
                                                style={{
                                                    width: `${roundNumber((currentMonthTasks?.manager_status + currentMonthTasks?.reviewer_status) / 2) || 0}%`,
                                                    borderRadius: 18,
                                                    transition: 'width 0.7s cubic-bezier(.4,2,.6,1)',
                                                }}
                                            />
                                        </div>
                                        {/* Percentage (on the right) */}
                                        <div className="min-w-[38px] w-[10%] text-[17px] text-white text-end mx-0"
                                            style={{
                                                fontWeight: 900,
                                                transition: 'color 0.2s ease'
                                            }}>
                                            {roundNumber((currentMonthTasks?.manager_status + currentMonthTasks?.reviewer_status) / 2) || 0}%
                                        </div>
                                    </div>
                                </div>
                                <div className='border-l-2 border-white p-1 h-12 w-0' />
                                {/* donut chart */}
                                <div className="flex flex-col justify-center items-center gap-2">
                                    <DonutChart value={currentMonthTasks?.performance || 0} size={90} color='url(#circularBlueGradient)' bg='#23263a' textColor='#fff' />
                                    <div className="flex p-2 rounded-2xl shadow gap-2">
                                        <h1>مهمة</h1>
                                        <h1>{currentMonthTasks?.tasksCount || 0}</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* lower card (monthly chart) */}
                        <div className="flex-1 flex flex-col justify-center items-center gap-4 text-white bg-[#2d3347] rounded-2xl shadow-md shadow-black px-2">
                            <h1 className="text-center font-bold">تحليل معدل تغيير الاداء</h1>
                            <ResponsiveContainer width="100%" height={200}>
                                <LineChart
                                    data={MONTHS_ARABIC.map(m => {
                                        const found = allTasks.find(t => t.monthNumber === m.monthNumber);
                                        return found ? { ...found, month: found.monthName } : { ...m, performance: 0 };
                                    })}
                                    margin={{ top: 6, right: 30, left: -25, bottom: -10 }}
                                >
                                    <CartesianGrid strokeDasharray="3 3" stroke="#4a5568" /> {/* optional grey grid */}
                                    <XAxis
                                        dataKey="month"
                                        axisLine={false}
                                        tickLine={false}
                                        tick={{ fontSize: 10, fill: "#ffffff" }} // ← white x-axis text
                                    />
                                    <YAxis
                                        axisLine={false}
                                        tickLine={false}
                                        tick={{ fontSize: 12, fill: "#ffffff" }} // ← white y-axis text
                                        domain={[0, 100]}
                                    />
                                    <Tooltip
                                        contentStyle={{
                                            backgroundColor: "#1a202c",
                                            border: "1px solid #4a5568",
                                            borderRadius: "6px",
                                            color: "#ffffff", // ← white tooltip text
                                        }}
                                        labelStyle={{ color: "#ffffff" }} // ← white label
                                        itemStyle={{ color: "#ffffff" }} // ← white items
                                    />
                                    <Line
                                        type="monotone"
                                        dataKey="performance"
                                        stroke="#fbbf24"
                                        strokeWidth={2}
                                        dot={{ r: 5, fill: "#fbbf24" }}
                                        activeDot={{ r: 7, stroke: "#fff", strokeWidth: 2 }}
                                        label={({ x, y, value }) => (
                                            <text
                                                x={x}
                                                y={y - 10} // move up a little
                                                textAnchor="middle"
                                                fill="#ffffff"
                                                fontSize={12}
                                                fontWeight="bold"
                                            >
                                                {value}%
                                            </text>
                                        )}
                                    />
                                </LineChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                    {/* right column */}
                    <div className="flex-1 h-full flex flex-col gap-4">
                        {/* upper card (total score) */}
                        <div className="flex-1 h-1/2 flex items-center gap-10 bg-[#2d3347] rounded-2xl shadow-md shadow-black px-2">
                            {/* total scores (finished and not finished) */}
                            <div className="flex flex-col gap-8 w-[45%]">
                                <div className="flex flex-col">
                                    <div className={`text-white text-center rounded p-2 bg-[#2f417a]`}>اجمالي عدد المهام المنجزة</div>
                                    <div className={`border-white p-2 border-2 rounded text-center font-bold mt-2 text-white`}>{currentMonthTasks?.tasks?.filter(t => t.assignee_status === 100).length || 0}</div>
                                </div>
                                <div className="flex flex-col">
                                    <div className={`text-white text-center rounded p-2 bg-[#2f417a]`}>اجمالي عدد المهام الغير منجزة</div>
                                    <div className={`border-white p-2 border-2 rounded text-center font-bold mt-2 text-white`}>{currentMonthTasks?.tasks?.filter(t => t.assignee_status !== 100).length || 0}</div>
                                </div>
                            </div>
                            <div className="w-0 h-32 border-white border-l-2" />
                            {/* 50% scores grouped by priority */}
                            <div className="flex flex-col gap-3.5 w-[45%]">
                                <div className={`text-white text-center rounded p-2 bg-[#2f417a]`}>مهام اقل من (%50)</div>
                                <div className="flex gap-2">
                                    <div className={`flex-1 border-white p-2 border-2 rounded text-center font-bold text-white`}>{currentMonthTasks?.tasks?.filter(t => t.assignee_status <= 50 && t.importance === "urgent").length || 0}</div>
                                    <div className={`flex-1 text-center rounded p-2 bg-[#5268b1] text-white`}>اولوية قصوي</div>
                                </div>
                                <div className="flex gap-2">
                                    <div className={`flex-1 border-white p-2 border-2 rounded text-center font-bold text-white`}>{currentMonthTasks?.tasks?.filter(t => t.assignee_status <= 50 && t.importance === "important").length || 0}</div>
                                    <div className={`flex-1 text-center rounded p-2 bg-[#5268b1] text-white`}>اولوية متوسطة</div>
                                </div>
                                <div className="flex gap-2">
                                    <div className={`flex-1 border-white p-2 border-2 rounded text-center font-bold text-white`}>{currentMonthTasks?.tasks?.filter(t => t.assignee_status <= 50 && t.importance === "normal").length || 0}</div>
                                    <div className={`flex-1 text-center rounded p-2 bg-[#5268b1] text-white`}>اولوية عادية</div>
                                </div>
                            </div>
                        </div>
                        {/* lower card (monthly chart) */}
                        <div className="flex-1 h-1/2 flex items-center">
                            <div className="w-full h-full flex flex-row-reverse gap-3 text-white text-xs cursor-pointer" onClick={() => setShowTablePopup(true)}>
                                {/* === Priority columns === */}
                                <div className="flex-1 flex flex-col gap-3">
                                    {/* === Top section: إجمالي العدد === */}
                                    <div className="h-2/6 overflow-hidden rounded-xl border border-white/30 bg-[#5268b1] shadow-sm">
                                        <table className="w-full h-full table-fixed border-collapse" dir="rtl">
                                            <thead>
                                                <tr className="bg-[#5268b1] border-b border-white/30">
                                                    <th className="py-2 text-center font-semibold border-l border-white/30">البند</th>
                                                    <th className="py-2 text-center font-semibold border-l border-white/30">أولوية قصوى</th>
                                                    <th className="py-2 text-center font-semibold border-l border-white/30">أولوية متوسطة</th>
                                                    <th className="py-2 text-center font-semibold">أولوية عادية</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr className="bg-[#2f417a] hover:bg-[#3b4e93] transition">
                                                    <td className="py-2 text-center border-l border-white/30">إجمالي العدد</td>
                                                    {[currentMonthTasks?.tasks?.filter(t => t.importance === "urgent").length || 0, currentMonthTasks?.tasks?.filter(t => t.importance === "important").length || 0, currentMonthTasks?.tasks?.filter(t => t.importance === "normal").length || 0].map(
                                                        (value, i) => (
                                                            <td key={i} className="py-2 text-center border-l border-white/30">
                                                                <span className="inline-flex items-center justify-center min-w-[2.25rem] px-2 h-6 rounded-full bg-white/20">
                                                                    {value}
                                                                </span>
                                                            </td>
                                                        )
                                                    )}
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* === Bottom section: other rows === */}
                                    <div className="h-4/6 overflow-hidden rounded-xl border border-white/30 bg-[#5268b1] shadow-sm">
                                        <table className="w-full h-full table-fixed border-collapse" dir="rtl">
                                            <tbody>
                                                {[
                                                    {
                                                        label: "إجمالي نسبة الاستكمال", values: [
                                                            `${roundNumber((test("urgent", "manager_status") + test("urgent", "reviewer_status")) / 2) || 0}%`,
                                                            `${roundNumber((test("important", "manager_status") + test("important", "reviewer_status")) / 2) || 0}%`,
                                                            `${roundNumber((test("normal", "manager_status") + test("normal", "reviewer_status")) / 2) || 0}%`
                                                        ]
                                                    },
                                                    {
                                                        label: "إجمالي مستوى الدقة", values: [
                                                            `${roundNumber((test("urgent", "manager_quality") + test("urgent", "reviewer_quality")) / 2) || 0}%`,
                                                            `${roundNumber((test("important", "manager_quality") + test("important", "reviewer_quality")) / 2) || 0}%`,
                                                            `${roundNumber((test("normal", "manager_quality") + test("normal", "reviewer_quality")) / 2) || 0}%`,
                                                        ]
                                                    },
                                                    {
                                                        label: "إجمالي معدل السرعة", values: [
                                                            `${roundNumber((test("urgent", "manager_speed") + test("urgent", "reviewer_speed")) / 2) || 0}%`,
                                                            `${roundNumber((test("important", "manager_speed") + test("important", "reviewer_speed")) / 2) || 0}%`,
                                                            `${roundNumber((test("normal", "manager_speed") + test("normal", "reviewer_speed")) / 2) || 0}%`,
                                                        ]
                                                    },
                                                    {
                                                        label: "إجمالي التقييم", values: [
                                                            `${roundNumber((((test("urgent", "manager_speed") + test("urgent", "reviewer_speed")) / 2) + ((test("urgent", "manager_quality") + test("urgent", "reviewer_quality")) / 2) + ((test("urgent", "manager_status") + test("urgent", "reviewer_status")) / 2) / 3)) || 0}%`,
                                                            `${roundNumber((((test("important", "manager_speed") + test("important", "reviewer_speed")) / 2) + ((test("important", "manager_quality") + test("important", "reviewer_quality")) / 2) + ((test("important", "manager_status") + test("important", "reviewer_status")) / 2) / 3)) || 0}%`,
                                                            `${roundNumber((((test("normal", "manager_speed") + test("normal", "reviewer_speed")) / 2) + ((test("normal", "manager_quality") + test("normal", "reviewer_quality")) / 2) + ((test("normal", "manager_status") + test("normal", "reviewer_status")) / 2) / 3)) || 0}%`,
                                                        ]
                                                    },
                                                ].map((row, index) => (
                                                    <tr
                                                        key={index}
                                                        className="bg-[#2f417a] border-t border-white/20 hover:bg-[#3b4e93] transition"
                                                    >
                                                        <td className="py-2 text-center border-l border-white/30">{row.label}</td>
                                                        {row.values.map((value, i) => (
                                                            <td key={i} className="py-2 text-center border-l border-white/30">
                                                                <span className="inline-flex items-center justify-center min-w-[2.25rem] px-2 h-6 rounded-full bg-white/20">
                                                                    {value}
                                                                </span>
                                                            </td>
                                                        ))}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                {/* === Total column (الإجمالي) === */}
                                <div className="flex-1 max-w-[6rem] flex flex-col gap-3">
                                    {/* === Top section (إجمالي العدد) === */}
                                    <div className="h-2/6 overflow-hidden rounded-xl border border-white/30 bg-[#4459a8] shadow-sm">
                                        <table className="w-full h-full border-collapse" dir="rtl">
                                            <thead>
                                                <tr className="bg-[#4459a8] border-b border-white/30">
                                                    <th className="py-2 text-center font-semibold">الإجمالي</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr className="bg-[#2f417a] hover:bg-[#3b4e93] transition">
                                                    <td className="py-2 text-center">
                                                        <span className="inline-flex items-center justify-center min-w-[2.25rem] px-2 h-6 rounded-full bg-white/20">
                                                            {currentMonthTasks?.tasksCount || 0}
                                                        </span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* === Bottom section (other rows) === */}
                                    <div className="h-4/6 overflow-hidden rounded-xl border border-white/30 bg-[#4459a8] shadow-sm">
                                        <table className="w-full h-full border-collapse" dir="rtl">
                                            <tbody>
                                                {[
                                                    { label: "إجمالي نسبة الاستكمال", value: `${roundNumber(((currentMonthTasks?.manager_status + currentMonthTasks?.reviewer_status) / 2) || 0)}%` },
                                                    { label: "إجمالي مستوى الدقة", value: `${roundNumber(((currentMonthTasks?.manager_quality + currentMonthTasks?.reviewer_quality) / 2) || 0)}%` },
                                                    { label: "إجمالي معدل السرعة", value: `${roundNumber(((currentMonthTasks?.manager_speed + currentMonthTasks?.reviewer_speed) / 2) || 0)}%` },
                                                    { label: "إجمالي التقييم", value: `${currentMonthTasks?.performance || 0}%` },
                                                ].map((row, index) => (
                                                    <tr
                                                        key={index}
                                                        className="bg-[#2f417a] border-t border-white/20 hover:bg-[#3b4e93] transition"
                                                    >
                                                        <td className="py-2 text-center">
                                                            <span className="inline-flex items-center justify-center min-w-[2.25rem] px-2 h-6 rounded-full bg-white/20">
                                                                {row.value}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* {pdfStatus && <PdfPages />} */}
            {/* {showTablePopup && (
                <TmsDashboardTables
                    onClose={() => setShowTablePopup(false)}
                    selectedMonthTasks={selectedMonthTasks}
                    selectedMonthDetails={selectedMonthDetails}
                />
            )} */}
        </>
    )
}

export default WatomsTmsDashboard;